import React from "react";
import IMG from "./customer-service.png";
import Header from "../../../../components/common/header";
import { RiKakaoTalkFill } from "react-icons/ri";
import { IoIosCall } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const BossSupport = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full h-[100vh] flex flex-col">
      {/* 헤더 */}
      <Header title="문의하기" showBackButton />

      {/* 본문 내용 */}
      <div className="flex-1 flex flex-col items-center p-4 h-full bg-[#F6F6F6]">
        <div className="flex flex-col items-center max-w-xs w-full">
          <div className="flex w-full justify-between">
            <div
              onClick={() => {
                navigate("/boss/my/support/contact-number");
              }}
              className="flex-1 px-6 py-3 bg-blue-500 text-white font-bold rounded-lg shadow-md hover:bg-blue-600 transition duration-300 mr-2"
            >
              <IoIosCall className="text-6xl" />
              전화로 문의
            </div>
            <a
              href="http://pf.kakao.com/_xawxcRn/chat"
              className="flex-1  px-6 py-3 bg-yellow-500 text-white font-bold rounded-lg shadow-md hover:bg-blue-600 transition duration-300 ml-2"
            >
              <RiKakaoTalkFill className="text-6xl" />
              채팅으로 문의
            </a>
          </div>
          <div className="flex w-full justify-between mt-4">
            <a
              href="https://docs.google.com/forms/d/1aqa_tsqz7hs_aGiIC_ZwptnwALSt3S1VBJkGWSb8UNI/viewform?edit_requested=true"
              className="text-xl flex-1 px-6 py-8 bg-purple-500 text-white font-bold rounded-lg shadow-xl hover:bg-blue-600 transition duration-300 mr-2"
            >
              {/* <IoIosCall className="text-6xl" /> */}
              기능 문의하기
              <div className="text-md">
                <div>- 기능문의</div>
                <div>- 버그 신고</div>
                <div>- 건의사항</div>
              </div>
            </a>
          </div>

          <div className="mt-4 text-center text-[#1562fc] text-xl font-normal">
            24시간 문의 가능
          </div>
        </div>
        <img
          className="w-[17rem] h-auto mt-4 mix-blend-color-burn"
          src={IMG}
          alt="Customer Service"
        />
      </div>

      {/* 하단 탭 */}
      {/* <BottomTab /> */}
    </div>
  );
};

export default BossSupport;
